import { values } from './enums'

const _enum = {
  ReportSubmissionGroupXml: 0,
  OutputReportGroupXml: 1
}

export const xsdSchemaTypes = {
  enumName: 'XsdSchemaTypes',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/xsdSchemaTypes.js